__turbopack_context__.v({
  "animated": "Box-module-scss-module__qWCIeG__animated",
  "box": "Box-module-scss-module__qWCIeG__box",
});
